import { render, staticRenderFns } from "./CloudStorageSetup.vue?vue&type=template&id=562f99f2&scoped=true&"
import script from "./CloudStorageSetup.vue?vue&type=script&lang=js&"
export * from "./CloudStorageSetup.vue?vue&type=script&lang=js&"
import style0 from "./CloudStorageSetup.vue?vue&type=style&index=0&id=562f99f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f99f2",
  null
  
)

export default component.exports